/*    
<summary>
  This functional component "ChangePhone 1" defines the props like initial values and functions for the child form 
  component.
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import toast from "react-hot-toast";
import React, { useEffect } from "react";
import { useStore } from "../../../../contexts/store-provider";
import { formatMessage } from "../../../../translations/format-message";
import ChangeCustomerPhone1Form from "../forms/change-customer-phone1-form";
import { IAddCustomer } from "../../../../models/forms/IAddCustomerManagement";
import { getStoreIdFromLocalStorage, getUserTypeFromLocalStorage } from "../../../../helpers/localstorage-helper";
import userTypeEnum from "../../../../constants/enums/user-type-enum";


interface IProps {
    id: number;
    modalClosed: () => void;
}

const ChangePhone1: React.FC<IProps> = (props) => {
    const { customerManagementStore } = useStore();
    const {
        UpdateCustomerService,
        addUpdateCustomerState,
        resetAddUpdateCustomerState,
        GetCustomerByIdService,
        customerDetail

    } = customerManagementStore;


    const initialValues: IAddCustomer = customerDetail;

    // useEffect(() => {
    //     if (props.id) {
    //         let userTypeFromLocalStorage = getUserTypeFromLocalStorage();
    //         GetCustomerByIdService(props.id,
    //             (userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.SuperAdmin] && userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.HeadQuarter])
    //             ? getStoreIdFromLocalStorage()
    //             : null);
    //     }
    // }, []);
    /**
     * The useEffect Hook lets you perform side effects in function component.
     * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while 
     * dependency "changePasswordSuccess" of the useEffect changed.
     */
    useEffect(() => {
        if (addUpdateCustomerState.success) {
              toast.success(formatMessage("updated_success"));
            onModalClosed();
        }
    }, [addUpdateCustomerState.success]);

    /**
     * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while 
     * dependency "changePasswordError" of the useEffect changed.
     */
    useEffect(() => {
        if (addUpdateCustomerState.error) {
            toast.error(formatMessage(addUpdateCustomerState.error));
            resetAddUpdateCustomerState();
        }
    }, [addUpdateCustomerState.error]);

    /**
     * This function changes the user password by provides new password and user Id  to "chagePassword" store funtion that 
     * send the request to Api.
     */
    const onSubmitForm = (values: { Phone1: string }) => {
        const submitData = {
            ...customerDetail,
            Phone1: values.Phone1,
             Dob:
                customerDetail.DobDate &&
                customerDetail.DobMonth &&
                customerDetail.DobYear &&
                customerDetail.DobDate > 0 &&
                customerDetail.DobMonth > 0 &&
                customerDetail.DobYear > 0
                ? `${customerDetail.DobYear}-${customerDetail.DobMonth}-${customerDetail.DobDate}`
                : null,
            DmDshs: customerDetail.DmDshs === "true" || customerDetail.DmDshs === true ? true : false,
        };
        if(customerDetail.Phone1 !== submitData.Phone1)      
            UpdateCustomerService(props.id, submitData, true);
        else{
            toast.success(formatMessage("updated_success"));
            onModalClosed();
        }
    };



    /**
     * This function closes the pop up modal and reset ChangePassword observables (success, inprogress and error).
     */
    const onModalClosed = () => {
        resetAddUpdateCustomerState();
        props.modalClosed();
    };

    return (
        <ChangeCustomerPhone1Form
            id={props.id}
            initialValues={initialValues}
            submitHandler={onSubmitForm}
            onModalClosed={onModalClosed}
            loading={addUpdateCustomerState.inProgress}
        />
    );
};

export default observer(ChangePhone1);
